import React from 'react';
import { HDR_CROSS_SELL } from '@rehub/pricing';
import { trackHdrEvent } from '../services/analytics';
import { supabase } from '../services/supabase';

const CROSS_SELL_LOGOS: Record<(typeof HDR_CROSS_SELL)[number]['id'], { src: string; className: string }> = {
  photoclear: {
    src: '/photoclear-logo-transparent.png',
    className: 'h-12 max-w-full',
  },
  staging: {
    src: '/virtual-staging-logo-transparent.png',
    className: 'h-10 max-w-[8.75rem]',
  },
  hyperdusk: {
    src: '/hyperdusk-logo-wordmark-alpha.png',
    className: 'h-8 max-w-[11.5rem]',
  },
  imagemotion: {
    src: '/imagemotion-logo.webp',
    className: 'h-6 max-w-[10.5rem]',
  },
};

export default function HdrCrossSell({
  imageUrl,
  disabled,
}: {
  imageUrl: string | null;
  disabled?: boolean;
}) {
  if (!imageUrl || disabled) return null;

  const open = async (url: string, id: string) => {
    trackHdrEvent('hdr_rehub_cross_sell_clicked', { destination: id });
    let hash = '';
    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (session?.access_token && session?.refresh_token) {
        hash = `#sso_access_token=${encodeURIComponent(session.access_token)}&sso_refresh_token=${encodeURIComponent(session.refresh_token)}`;
      }
    } catch {
      /* continue without SSO */
    }
    window.open(`${url}?imageUrl=${encodeURIComponent(imageUrl)}${hash}`, '_blank', 'noopener,noreferrer');
  };

  return (
    <section className="border-t border-slate-800 bg-slate-950/80 px-4 py-5">
      <div className="mx-auto max-w-5xl">
        <h2 className="text-sm font-semibold uppercase tracking-wider text-slate-400">
          Take this image further
        </h2>
        <p className="mt-1 text-sm text-slate-500">
          These steps use ReHub Credits, not HDR Images.
        </p>
        <div className="mt-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {HDR_CROSS_SELL.map((item) => {
            const logo = CROSS_SELL_LOGOS[item.id];
            return (
              <button
                key={item.id}
                type="button"
                onClick={() => open(item.url, item.id)}
                className="rounded-2xl border border-slate-800 bg-slate-900/70 p-4 text-left transition-colors hover:border-sky-500/40"
              >
                <div className="mb-3 flex h-14 items-center">
                  <img
                    src={logo.src}
                    alt=""
                    className={`w-auto origin-left object-contain object-left ${logo.className}`}
                  />
                </div>
                <p className="font-semibold text-white">{item.name}</p>
                <p className="mt-1 text-sm text-slate-400">{item.description}</p>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
